import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from '@constants'
import { useToast } from "@hooks"
import { formData, tableData } from "../@signals"


export default function useForm() {

    const { showToast } = useToast()

    const setModalData = (row) => {
        const conditions = { ...row?.conditions }

        if ('priceUnderReference' in conditions) {
            conditions.percentagePriceUnder = conditions.priceUnderReference
            conditions.priceUnderReference = 'true'
        } else {
            conditions.priceUnderReference = 'false'
            conditions.percentagePriceUnder = -1
        }

        formData.value = {
            reportNameForm: row?.reportName || '',
            countryForm: row?.filters?.country || [],
            retailerForm: row?.retailers?.map(r => r.data.id) || [],
            brandForm: row?.brands?.map(b => b.id) || [],
            skuGroupForm: row?.skuGroup?.map(sg => sg.id) || null,
            skuForm: row?.sku?.map(s => s.id) || [],
            emailCC: row?.emails || [],
            conditions: conditions,
            frequencyForm: row?.frequency || '',
            reportTypeForm: row?.reportTypeKey || '',
            splitKpi: row?.filters?.splitKpi || [],
            sellers: row?.filters?.sellers || []
        }
    }

    const rowFormatted = row => {
        const conditions = formData.value?.conditions || {}
        if ('priceUnderReference' in conditions) {
            if (!JSON.parse(conditions.priceUnderReference)) {
                delete conditions.priceUnderReference
                delete conditions.percentagePriceUnder
            }
            conditions.priceUnderReference = conditions.percentagePriceUnder
            delete conditions.percentagePriceUnder
        }

        if('includeOnlyNewProducts' in conditions) {
            conditions.includeOnlyNewProducts = conditions.includeOnlyNewProducts === 'Yes'
        }

        return {
            reportID: null,
            ...row,
            reportName: formData.value.reportNameForm,
            emails: formData.value.emailCC,
            markets: formData.value.countryForm,
            brandsID: formData.value.brandForm,
            retailersID: formData.value.retailerForm,
            skuGroupsID: formData.value.skuGroupForm,
            skusID: formData.value.skuForm,
            splitKpi: formData.value.splitKpi,
            conditions: conditions,
            frequency: formData.value.frequencyForm,
            sellers: formData.value.sellers
        }

    }

    const updateTableRow = rowUpdate => tableData.value = tableData.value.map(row => {
        return row.reportID === rowUpdate.reportID ? { ...row, ...rowUpdate } : row
    })

    const setNewRow = newRow => {
        tableData.value = [  newRow, ...tableData.value ]
    }
    
    const saveRow = rowUpdated => {
        try {
            showToast.promise(postSubmit(`${WEBBACK_V2_API}/reports/update`, rowUpdated).then(res => {
                updateTableRow({...rowUpdated, ...res})
            }).catch(e => {
                showToast.error(e)
            }), {
                success: 'Report updated successfully',
                loading: 'Updating...',
            })
        }catch (error) {
            showToast.error()
        } 
    }

    const deleteRow = rowUpdated => {
        try {
            showToast.confirm("Are you sure you want to delete?", {
                onSubmit: () => {
                    showToast.promise(postSubmit(`${WEBBACK_V2_API}/reports/delete`, rowUpdated).then(res => {
                        deleteTableRow(rowUpdated)
                    }).catch(e => {
                        showToast.error(e)
                    }), {
                        success: 'Report deleted successfully',
                        loading: 'Deleting...',
                    })
                }
		    })
        } catch {
            showToast.error()
        }
    }

    const deleteTableRow = alertToDelete => tableData.value = tableData.value.filter(row => row.reportID !== alertToDelete.reportID)

	return {
		setModalData,
        updateTableRow,
        setNewRow,
        rowFormatted,
        saveRow,
        deleteRow
	}
}